module.exports = __webpack_public_path__ + "static/media/kids.b8ed4200.png";